import React from "react";

export const GetgemsIcon = ({ className }: { className: string }) => {
  return (
    <div className={className}>
      <img src="/assets/getgems.svg" alt="getgems" />
    </div>
  );
};
